import * as FRAGMENTS from './fragments';
// Recursively replace fragment placeholders in the query with actual fragment definitions, preserving indentation
export var processFragments = function (query, fragments) {
  if (fragments === void 0) {
    fragments = FRAGMENTS;
  }
  var previousQuery;
  do {
    previousQuery = query;
    query = query.replace(/(\s*)\.\.\.([A-Za-z0-9_]+)/g, function (match, indent, fragmentName) {
      if (fragments[fragmentName]) {
        // Indent each line of the fragment definition
        var fragmentLines = fragments[fragmentName].split('\n').map(function (line) {
          return "".concat(indent).concat(line);
        });
        return fragmentLines.join('');
      } else {
        // Replace undefined fragments with nothing
        return '';
      }
    });
  } while (query !== previousQuery); // Continue until no changes are made
  return query;
};